var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08094 6.64844V6.65844C7.64994 6.65844 7.30094 7.00844 7.30094 7.43844C7.30094 7.86844 7.64994 8.21844 8.08094 8.21844H11.0699C11.5009 8.21844 11.8509 7.86844 11.8509 7.42744C11.8509 6.99844 11.5009 6.64844 11.0699 6.64844H8.08094ZM15.9209 12.7384H8.08094C7.64994 12.7384 7.30094 12.3884 7.30094 11.9584C7.30094 11.5284 7.64994 11.1774 8.08094 11.1774H15.9209C16.3509 11.1774 16.7009 11.5284 16.7009 11.9584C16.7009 12.3884 16.3509 12.7384 15.9209 12.7384ZM15.9209 17.3084H8.08094C7.78094 17.3484 7.49094 17.1984 7.33094 16.9484C7.17094 16.6884 7.17094 16.3584 7.33094 16.1084C7.49094 15.8484 7.78094 15.7084 8.08094 15.7384H15.9209C16.3199 15.7784 16.6209 16.1184 16.6209 16.5284C16.6209 16.9274 16.3199 17.2684 15.9209 17.3084Z",
    fill: "#0A132C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e0e0216797413a743bb5d67871f57300.svg";
export { ForwardRef as ReactComponent };